import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { PERMISSIONS } from '../../../../../enum/constants';
import { BaseService } from '../../../../../services/base.service';
import { Tab } from '../../../../../components/tabs/interfaces/tab.interface';
import { TeamTab } from '../../../../../components/tabs/enums/tabs.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TeamComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();
  private readonly teamTabs: Tab<TeamTab>[] = [
    {
      name: 'managers',
      value: TeamTab.MANAGERS,
      default: true,
    },
    {
      name: 'roles',
      value: TeamTab.GROUPS,
    },
  ];
  protected tabs: Tab<TeamTab>[] = [];
  protected activeTab!: Tab<TeamTab>;
  protected teamLoader: boolean = false;

  constructor(
    private readonly baseService: BaseService,
    private readonly router: Router,
  ) {}

  public ngOnInit() {
    const canViewTeam = this.baseService.isHasPermission(PERMISSIONS.TEAM_ACCESS);
    const canManageTeam = this.baseService.isHasPermission(PERMISSIONS.TEAM_ACTION);
    const canChangeOwnRole = this.baseService.isHasPermission(PERMISSIONS.ROLE_CHANGE_OWN_ROLE_ACCESS);

    if (!canViewTeam && !canManageTeam && !canChangeOwnRole) {
      this.router.navigate(['/crm/support']);
      return;
    }

    this.tabs =
      canViewTeam || canManageTeam
        ? this.teamTabs
        : [
            {
              name: 'managers',
              value: TeamTab.MANAGERS,
              default: true,
            },
          ];
  }

  public ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public onChangeTab(selectedTab: Tab<TeamTab>) {
    this.activeTab = selectedTab;
  }

  protected readonly TeamTab = TeamTab;
}
